import { LayoutElement } from "./layout.element";
import JsBarcode from "jsbarcode"
import QRCode from 'qrcode'
import { HtmlPaging } from "./html.paging";
import { CanvasListDraw } from "./layout.canvas.list";
import { EnvUtil, StringUtil, TypeClass } from "./layout.util";
import { Constant } from "./layout.constant";

class HtmlPrint {
    static #svgNS = "http://www.w3.org/2000/svg";
    static preview(option) {
        this.#initSystem()
        let template = {}
        if (TypeClass.checkType(option.template) == "string") {
            template = JSON.parse(option.template)
        } else if (TypeClass.checkType(option.template) == "json") {
            template = option.template
        }
        let datasource = {}
        if (option.datasource) {
            if (TypeClass.checkType(option.datasource) == "string") {
                datasource = JSON.parse(option.datasource)
            } else if (TypeClass.checkType(option.datasource) == "json") {
                datasource = option.datasource
            }
        }
        const iframe = this.#createIframe(template, datasource)
        if (EnvUtil.detectBrowser() == 'Firefox') {
            iframe.onload = () => {
                this.#createPages(iframe, template, datasource, option.forcePage)
            }
        } else {
            this.#createPages(iframe, template, datasource, option.forcePage)
        }
    }

    /**
     * 创建并挂载iframe
     * 
     * @returns 
     */
    static #createIframe() {
        const iframe = document.createElement("iframe")
        iframe.style.display = "none";
        iframe.style.padding = "0px"
        iframe.style.margin = "0px"

        document.body.append(iframe)
        iframe.contentWindow.onafterprint = function (e) {
            document.body.removeChild(iframe)
        };
        return iframe
    }



    static #createPages(iframe, template, datasource, forcePage = true) {
        if (Array.isArray(datasource)) {
            let index = 0
            const nextPage = () => {
                index++;
                if (index < datasource.length) {
                    if (forcePage) {
                        this.#createNewPage(iframe)
                    }
                    printPage()
                } else {
                    iframe.contentWindow.print()
                }
            }

            const printPage = () => {
                this.#renderContent(iframe, template, datasource[index], forcePage, nextPage)
            }
            this.#renderStyle(iframe, template)
            printPage()
        } else {
            this.#renderStyle(iframe, template)
            this.#renderContent(iframe, template, datasource, forcePage, () => {
                iframe.contentWindow.print()
            })
        }
    }

    static #createNewPage(iframe) {
        const ifrdocument = iframe.contentWindow.document;
        const pagdiv = ifrdocument.createElement("div");
        pagdiv.classList.add("page-break")
        ifrdocument.body.append(pagdiv)
    }

    static #renderStyle(iframe, template) {
        var ifrdocument = iframe.contentWindow.document;
        //设置打印格式
        const direction = `${template.direction == '1' ? 'landscape' : 'portrait'}`
        {
            var style = ifrdocument.createElement('style');
            style.innerHTML = `@media print{@page{size:${direction} !important;;margin:0;padding:0}body{margin:0;padding:0;font-family:Arial,sans-serif}header,footer,.no-print,.print-header,.print-footer{display:none !important}@page{margin-top:0;margin-bottom:0}body:before,body:after{display:none !important}@page{-moz-print-header:none;-moz-print-footer:none}table{page-break-inside:avoid}.page-break{page-break-after:always}}`;
            ifrdocument.head.appendChild(style);
        }
        {
            var style = ifrdocument.createElement('style');
            style.innerHTML = `html,body{margin:0px;padding:0px}`;
            ifrdocument.head.appendChild(style);
        }
    }

    /**
     * 设置打印格式纸张等
     * 
     * @param {*} iframe 
     * @param {*} template 
     * @param {*} datasource 
     */
    static #renderContent(iframe, template, datasource, forcePage, printaction) {
        var pagecount = HtmlPaging.paging(template, datasource);
        var ifrdocument = iframe.contentWindow.document;
        let pageindex = 0
        const printPageEnd = () => {
            if (pageindex < pagecount) {
                if (forcePage) {
                    this.#createNewPage(iframe)
                }
                createNewPageContent()
            } else {
                //回调
                printaction()
            }
        }

        //创建页面内容
        const createNewPageContent = () => {
            pageindex++;
            const svgElement = ifrdocument.createElementNS(this.#svgNS, "svg");
            if (template.direction == '1') {
                svgElement.setAttribute("width", `${template.height}mm`);
                svgElement.setAttribute("height", `${template.width}mm`);
            } else {
                svgElement.setAttribute("width", `${template.width}mm`);
                svgElement.setAttribute("height", `${template.height}mm`);
            }
            ifrdocument.body.append(svgElement)
            datasource.pagenum = pageindex
            datasource.pagecount = pagecount
            datasource.date = new Date().pattern("yyyy-MM-dd")
            datasource.datetime = new Date().pattern("yyyy-MM-dd HH:mm:ss")
            this.#drawElement(ifrdocument, svgElement, template, datasource, 0, pageindex, printPageEnd);
        }
        createNewPageContent();
    }



    /**
     * 生成打印内容
     * 
     * @param {*} ifrdocument 
     * @param {*} svgElement 
     * @param {*} template 
     * @param {*} datasource 
     * @param {*} index 
     * @param {*} callback 
     */
    static #drawElement(ifrdocument, svgElement, template, datasource, index, pageindex, callback) {
        if (index < template.children.length) {
            const element = template.children[index]
            if (element.cls == LayoutElement.ELEMENT_LINE) {

                this.#drawLineElement(ifrdocument, svgElement, template, datasource, index, pageindex, callback)

            } else if (element.cls == LayoutElement.ELEMENT_TEXT) {

                this.#drawTextElement(ifrdocument, svgElement, template, datasource, index, pageindex, callback)

            } else if (element.cls == LayoutElement.ELEMENT_IMAGE) {

                this.#drawImageElement(ifrdocument, svgElement, template, datasource, index, pageindex, callback)

            } else if (element.cls == LayoutElement.ELEMENT_BARCODE) {

                this.#drawBarCodeElement(ifrdocument, svgElement, template, datasource, index, pageindex, callback)

            } else if (element.cls == LayoutElement.ELEMENT_QRCODE) {

                this.#drawQrCodeElement(ifrdocument, svgElement, template, datasource, index, pageindex, callback)

            } else if (element.cls == LayoutElement.ELEMENT_LIST) {

                this.#drawListElement(ifrdocument, svgElement, template, datasource, index, pageindex, callback)

            }
        } else {
            callback();
        }
    }

    static #drawLineElement(ifedoc, svgElement, template, datasource, index, pageindex, callback) {
        const element = template.children[index]
        if (element.type == Constant.LINE_TYPE_ELLI) {
            this.#drawElli(ifedoc, svgElement, element.ax1, element.ay1, element.ax2, element.ay2, element.color, element.weight)
        } else if (element.type == Constant.LINE_TYPE_RECT) {
            this.#drawRect(ifedoc, svgElement, element.ax1, element.ay1, element.ax2, element.ay2, element.color, element.weight)
        } else {
            this.#drawLine(ifedoc, svgElement, element.ax1, element.ay1, element.ax2, element.ay2, element.color, element.weight)
        }
        this.#drawElement(ifedoc, svgElement, template, datasource, index + 1, pageindex, callback)
    }


    static #drawTextElement(ifedoc, svgElement, template, datasource, index, pageindex, callback) {
        let element = template.children[index]
        element = Object.assign(LayoutElement.defaultTextElement(), element)
        let text = ""
        if (element.type == '1') {
            if (datasource.hasOwnProperty(element.text)) {
                text = datasource[element.text]
            }
        } else if (element.type == '2') {
            text = element.text
        } else {
            text = this.#render(element.text, datasource)
        }

        this.#drawRectText(ifedoc, svgElement, {
            ax: element.ax1,
            ay: element.ay1,
            width: element.ax2 - element.ax1,
            height: element.ay2 - element.ay1,
        }, text, element.font, element.size, element.color, element.align, element.bold, element.italic, element.vertical)
        this.#drawElement(ifedoc, svgElement, template, datasource, index + 1, pageindex, callback)
    }


    static #drawBarCodeElement(ifedoc, svgElement, template, datasource, index, pageindex, callback) {
        const element = template.children[index]
        const image = ifedoc.createElementNS(this.#svgNS, "image");
        image.setAttribute("x", `${element.ax1}mm`);
        image.setAttribute("y", `${element.ay1}mm`);
        image.setAttribute("width", `${element.ax2 - element.ax1}mm`);
        image.setAttribute("height", `${element.ay2 - element.ay1}mm`);
        image.setAttribute("preserveAspectRatio", "none");
        svgElement.appendChild(image)
        let code = element.code;
        if (element.type == '1') {
            if (datasource.hasOwnProperty(element.code)) {
                code = datasource[element.code]
            }
        }
        const img = new Image();
        JsBarcode(img, element.code);
        img.onload = () => {
            image.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", img.src);
            image.addEventListener('load', () => {
                this.#drawElement(ifedoc, svgElement, template, datasource, index + 1, pageindex, callback)
            });
        }
    }

    static #drawQrCodeElement(ifedoc, svgElement, template, datasource, index, pageindex, callback) {
        const element = template.children[index]
        const image = ifedoc.createElementNS(this.#svgNS, "image");
        image.setAttribute("x", `${element.ax1}mm`);
        image.setAttribute("y", `${element.ay1}mm`);
        image.setAttribute("width", `${element.ax2 - element.ax1}mm`);
        image.setAttribute("height", `${element.ay2 - element.ay1}mm`);
        image.setAttribute("preserveAspectRatio", "none");

        let code = element.code;
        if (element.type == '1') {
            if (datasource.hasOwnProperty(element.code)) {
                code = datasource[element.code]
            }
        }

        QRCode.toDataURL(code).then(src => {
            console.info(src)
            image.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", src);
            svgElement.appendChild(image)
            image.addEventListener('load', () => {
                this.#drawElement(ifedoc, svgElement, template, datasource, index + 1, pageindex, callback)
            });
        }).catch(err => {
            console.error(err)
            this.#drawElement(ifedoc, svgElement, template, datasource, index + 1, pageindex, callback)

        })
    }

    static #drawImageElement(ifedoc, svgElement, template, datasource, index, pageindex, callback) {
        const element = template.children[index]
        const image = ifedoc.createElementNS(this.#svgNS, "image");
        image.setAttribute("x", `${element.ax1}mm`);
        image.setAttribute("y", `${element.ay1}mm`);
        image.setAttribute("width", `${element.ax2 - element.ax1}mm`);
        image.setAttribute("height", `${element.ay2 - element.ay1}mm`);
        image.setAttribute("preserveAspectRatio", "none");
        image.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", element.code);
        svgElement.appendChild(image)
        image.addEventListener('load', () => {
            this.#drawElement(ifedoc, svgElement, template, datasource, index + 1, pageindex, callback)
        });

    }

    static #drawListElement(ifedoc, svgElement, template, datasource, index, pageindex, callback) {
        const element = template.children[index]
        const pageRowCount = element.pageRowCount
        const pagerow = element.rows.filter((e, i) => i >= (pageindex - 1) * pageRowCount && i < (pageindex) * pageRowCount)

        element.summary[`pcount`] = pagerow.length
        for (let index = 0; index < element.cols.length; index++) {
            const col = element.cols[index];
            col.padding = 1;
            element.summary[`psum(${col.field})`] = 0
        }
        for (let index = 0; index < pagerow.length; index++) {
            const row = pagerow[index];
            for (let index = 0; index < element.cols.length; index++) {
                const col = element.cols[index];
                element.summary[`psum(${col.field})`] = element.summary[`psum(${col.field})`] + StringUtil.toNumber(row[col.field])
            }
        }

        CanvasListDraw.drawListBorder(
            element,
            pagerow,
            (value) => {
                return value
            },
            (border, x1, y1, x2, y2, weight, color) => {
                if (border) {
                    this.#drawLine(ifedoc, svgElement, x1, y1, x2, y2, color, weight)
                }
            }
        )

        CanvasListDraw.drawListContent(
            element,
            pagerow,
            (value) => {
                return value
            },
            (style, text, rect) => {
                const textstr = this.#render(text, Object.assign(datasource, element.summary))
                this.#drawRectText(ifedoc, svgElement, rect, textstr, style.font, style.size, style.color, style.align, style.bold, style.italic)
            },
            (text, rect) => {
            },
            (text, rect) => {
            },
            (text, rect) => {
            }
        )
        this.#drawElement(ifedoc, svgElement, template, datasource, index + 1, pageindex, callback)
    }

    static #drawLine(ifedoc, svgElement, x1, y1, x2, y2, color, weight) {
        const line = ifedoc.createElementNS(this.#svgNS, "line");
        line.setAttribute("x1", `${x1}mm`);
        line.setAttribute("y1", `${y1}mm`);
        line.setAttribute("x2", `${x2}mm`);
        line.setAttribute("y2", `${y2}mm`);
        line.setAttribute("stroke", color);
        line.setAttribute("stroke-width", weight);
        svgElement.appendChild(line);
    }


    static #drawElli(ifedoc, svgElement, x1, y1, x2, y2, color, weight) {
        const line = ifedoc.createElementNS(this.#svgNS, "ellipse");
        line.setAttribute("cx", `${x1 + (x2 - x1) / 2}mm`);
        line.setAttribute("cy", `${y1 + (y2 - y1) / 2}mm`);
        line.setAttribute("rx", `${(x2 - x1) / 2}mm`);
        line.setAttribute("ry", `${(y2 - y1) / 2}mm`);
        line.setAttribute("stroke", color);
        line.setAttribute("fill-opacity", 0);
        line.setAttribute("stroke-width", weight);
        svgElement.appendChild(line);
    }

    static #drawRect(ifedoc, svgElement, x1, y1, x2, y2, color, weight) {
        const line = ifedoc.createElementNS(this.#svgNS, "rect");
        line.setAttribute("x", `${x1}mm`);
        line.setAttribute("y", `${y1}mm`);
        line.setAttribute("width", `${x2 - x1}mm`);
        line.setAttribute("height", `${y2 - y1}mm`);
        line.setAttribute("stroke", color);
        line.setAttribute("fill-opacity", 0);
        line.setAttribute("stroke-width", weight);
        svgElement.appendChild(line);
    }

    static #drawRectText(ifedoc, svgElement, rect, textstr, family, size, color, align, bold, italic, vertical) {
        const text = ifedoc.createElementNS(this.#svgNS, "foreignObject");
        text.setAttribute("x", `${rect.ax}mm`);
        text.setAttribute("y", `${rect.ay}mm`);
        text.setAttribute("width", `${rect.width}mm`);
        text.setAttribute("height", `${rect.height}mm`);
        const htmlDiv = ifedoc.createElementNS("http://www.w3.org/1999/xhtml", "div");

        let verticalalign = "center"
        if (Constant.VERTICAL_TOP == vertical) {
            verticalalign = "start";
        } else if (Constant.VERTICAL_BOTTOM == vertical) {
            verticalalign = "end";
        }

        htmlDiv.setAttribute("style", `height:${rect.height}mm;display:flex;align-items:${verticalalign};justify-content:${align};font-family:'${family}';font-size: ${size}px;${bold ? "font-weight:700;" : ""}${italic ? "font-style: italic" : ""}color:${color};`);
        htmlDiv.textContent = textstr;
        text.append(htmlDiv)
        svgElement.appendChild(text);
    }

    static #render(template, context) {
        //被转义的的分隔符 { 和 } 不应该被渲染，分隔符与变量之间允许有空白字符
        var tokenReg = /(\\)?\{([^\{\}\\]+)(\\)?\}/g;
        if (StringUtil.isEmptyString(template)) {
            return "";
        }
        return template.replace(tokenReg, function (word, slash1, token, slash2) {
            //如果有转义的\{或\}替换转义字符
            if (slash1 || slash2) {
                return word.replace('\\', '');
            }
            // 切割 token ,实现级联的变量也可以展开
            var variables = token.replace(/\s/g, '').split('.');
            var currentObject = context;
            var i, length, variable;

            for (i = 0, length = variables.length; i < length; ++i) {
                variable = variables[i];
                currentObject = currentObject[variable];
                // 如果当前索引的对象不存在，则直接返回空字符串。
                if (currentObject === undefined || currentObject === null) return '';
            }
            return currentObject;
        })
    }




    static #initSystem() {
        Date.prototype.pattern = function (format) {
            let we = this.getDay();                                 // 星期
            let qut = Math.floor((this.getMonth() + 3) / 3).toString(); // 季度
            const opt = {
                "y+": this.getFullYear().toString(),                 // 年
                "M+": (this.getMonth() + 1).toString(),                // 月(月份从0开始，要+1)
                "d+": this.getDate().toString(),                     // 日
                "H+": this.getHours().toString(),                    // 时
                "h+": this.getHours() % 12 === 0 ? "12" : (this.getHours() % 12).toString(), // 小时
                "m+": this.getMinutes().toString(),                  // 分
                "s+": this.getSeconds().toString(),                  // 秒
                "q+": qut, // 季度
            };
            const week = {      // 中文数字 (星期)
                "0": "日",
                "1": "一",
                "2": "二",
                "3": "三",
                "4": "四",
                "5": "五",
                "6": "六"
            };
            const quarter = {   // 中文数字（季度） 
                "1": "一",
                "2": "二",
                "3": "三",
                "4": "四",
            };
            if (/(W+)/.test(format)) {
                format = format.replace(RegExp.$1, (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '星期' + week[we] : '周' + week[we]) : week[we]))
            };
            if (/(Q+)/.test(format)) {
                // 输入一个Q，只输出一个中文数字，输入4个Q，则拼接上字符串 
                format = format.replace(RegExp.$1, (RegExp.$1.length == 4 ? '第' + quarter[qut] + '季度' : quarter[qut]));
            };
            for (let k in opt) {
                let ret = new RegExp("(" + k + ")").exec(format);
                if (ret) {
                    // 若输入的长度不为1，则前面补零
                    format = format.replace(ret[1], (ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')))
                }
            };
            return format;
        }
    }
}

export {
    HtmlPrint
}